export const environment = { 
    env: "prod",
    version: "1.17.0",
    apiBaseUrl: "https://api.caremoni.carekarte.jp",
    tokenUrl: "https://js1r6og6j5.execute-api.ap-northeast-1.amazonaws.com/Prod",
    authUrl: "https://apxodvi5ul.execute-api.ap-northeast-1.amazonaws.com/Prod",
    avatarUrl: "https://caremoni.carekarte.jp",
    useFirebase: true,
    firebaseConfig: {
        apiKey: "AIzaSyD7Zg37OWcbJIrE90aKXIQRnV34Da21v9g",
        authDomain: "caremoni-production.firebaseapp.com",
        databaseURL: "https://caremoni-production-default-rtdb.asia-southeast1.firebasedatabase.app",
        projectId: "caremoni-production",
        storageBucket: "caremoni-production.firebasestorage.app",
        messagingSenderId: "340269184859",
        appId: "1:340269184859:web:d545751ef1a99c934c0c7e",
        measurementId: "G-ZH6TJRLHZ0"
    },
    saucerLogApiUrl: 'https://ichrfnme4j.execute-api.ap-northeast-1.amazonaws.com/Prod/',
    saucerLogToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJtb2R1bGUiOiJDQVJFTU9OSSIsImlhdCI6MTc1OTM3NzExNn0.b7EJ2jEU6KOHKdhw-Ll71GQa1e6ALKjEDIdCQG8b3E8'
};
